<template>
  <VToolbar app dark clipped-left fixed class="primary">
    <VToolbarTitle>
      <VToolbarSideIcon v-if="isLoggedIn" @click.stop="toggleDrawer" />
    </VToolbarTitle>
    <img :src="`${publicPath}img/typless-logo.png`" height="36px" class="pl-2 mt-2 pr-4" />
    <VDivider vertical style="background-color: white" />
    <VToolbarItems v-if="isLoggedIn" style="width: 100%">
      <VBtn color="white" flat to="/dashboard"> Računi </VBtn>
      <VBtn color="white" flat to="/splitting"> Ločevanje računov </VBtn>
      <VBtn color="white" flat to="/history"> Zgodovina </VBtn>
      <VBtn color="white" flat to="/settings"> Nastavitve </VBtn>
      <VSpacer />
      <VBtn color="white" flat @click="logOut"> Odjava<VIcon right> exit_to_app </VIcon> </VBtn>
    </VToolbarItems>
  </VToolbar>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Toolbar',
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
      drawerOpened: 'drawerOpened',
    }),
  },
  methods: {
    toggleDrawer() {
      this.$store.dispatch('setDrawerStateAction', !this.drawerOpened);
    },
    logOut() {
      this.$store.dispatch('userSignout');
      this.$router.push({ path: 'login' });
    },
  },
};
</script>
<style scoped></style>
